import { apiCall } from 'services/api';

export const forgotPassword = async (data) => {
  return await apiCall({
    url: '/v1/auth/forgot-password',
    data,
    method: 'POST',
  });
};
